import React from 'react';
import { Steps, Card, Button, Row, Col, Space } from 'antd';
import {
  UserOutlined,
  SafetyOutlined,
  BankOutlined,
  CheckCircleOutlined,
  RocketOutlined,
  SecurityScanOutlined,
} from '@ant-design/icons';

interface StepContentProps {
  current: number;
  onNext: () => void;
  onPrev: () => void;
}

const IntroductionStep: React.FC<StepContentProps> = ({ onNext }) => {
  return (
    <div className="enterprise-page-container" style={{ background: '#f5f7fa', minHeight: '100vh', paddingTop: '40px' }}>
      <div className="enterprise-content-wrapper" style={{ padding: '20px 24px' }}>
        {/* 主要内容区 */}
        <div className="enterprise-welcome-container">
          <div className="enterprise-welcome-content enterprise-fade-in" style={{ maxWidth: '900px', margin: '0 auto' }}>
            {/* 欢迎标题 */}
            <div className="enterprise-welcome-header" style={{ textAlign: 'center', marginBottom: 48 }}>
              <div className="enterprise-welcome-title" style={{ fontSize: '36px', fontWeight: 600, color: '#262626', marginBottom: 16 }}>
                欢迎使用数据交易所
              </div>
              <div className="enterprise-welcome-subtitle" style={{ fontSize: '18px', color: '#595959' }}>
                开通账户，即可享受数据交易、资金管理等完整服务
              </div>
            </div>

            {/* 核心价值展示 */}
            <div className="enterprise-features-grid enterprise-slide-up" style={{ animationDelay: '0.2s', marginBottom: 48 }}>
              <Row gutter={[32, 32]}>
                <Col xs={24} sm={8}>
                  <div className="enterprise-feature-card enterprise-hover-lift" style={{ background: '#ffffff', border: 'none', borderRadius: '8px', padding: '32px 24px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)' }}>
                    <div className="enterprise-feature-icon" style={{ fontSize: '24px', color: '#1890ff', marginBottom: 16 }}>
                      <SecurityScanOutlined />
                    </div>
                    <div className="enterprise-feature-title" style={{ fontSize: '18px', fontWeight: 600, color: '#262626', marginBottom: 8 }}>安全便捷</div>
                    <div className="enterprise-feature-description" style={{ fontSize: '14px', color: '#8c8c8c' }}>银行级安全保障</div>
                  </div>
                </Col>
                <Col xs={24} sm={8}>
                  <div className="enterprise-feature-card enterprise-hover-lift" style={{ background: '#ffffff', border: 'none', borderRadius: '8px', padding: '32px 24px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)' }}>
                    <div className="enterprise-feature-icon" style={{ fontSize: '24px', color: '#1890ff', marginBottom: 16 }}>
                      <SafetyOutlined />
                    </div>
                    <div className="enterprise-feature-title" style={{ fontSize: '18px', fontWeight: 600, color: '#262626', marginBottom: 8 }}>合规透明</div>
                    <div className="enterprise-feature-description" style={{ fontSize: '14px', color: '#8c8c8c' }}>全程可追溯管理</div>
                  </div>
                </Col>
                <Col xs={24} sm={8}>
                  <div className="enterprise-feature-card enterprise-hover-lift" style={{ background: '#ffffff', border: 'none', borderRadius: '8px', padding: '32px 24px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)' }}>
                    <div className="enterprise-feature-icon" style={{ fontSize: '24px', color: '#1890ff', marginBottom: 16 }}>
                      <RocketOutlined />
                    </div>
                    <div className="enterprise-feature-title" style={{ fontSize: '18px', fontWeight: 600, color: '#262626', marginBottom: 8 }}>高效专业</div>
                    <div className="enterprise-feature-description" style={{ fontSize: '14px', color: '#8c8c8c' }}>一站式服务体验</div>
                  </div>
                </Col>
              </Row>
            </div>

            {/* 开户按钮 */}
            <div className="enterprise-cta-section enterprise-scale-in" style={{ animationDelay: '0.4s', textAlign: 'center', marginBottom: 48 }}>
              <Button 
                type="primary" 
                size="large"
                icon={<RocketOutlined />}
                onClick={onNext}
                className="enterprise-cta-button"
                style={{
                  height: '56px',
                  fontSize: '18px',
                  fontWeight: 600,
                  padding: '0 48px',
                  background: '#1890ff',
                  border: 'none',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)'
                }}
              >
                立即开通账户
              </Button>
            </div>
          </div>
        </div>

        {/* 开户流程简介 */}
        <div className="enterprise-slide-up" style={{ animationDelay: '0.6s', maxWidth: '900px', margin: '0 auto' }}>
          <Card 
            className="enterprise-card enterprise-process-card"
            style={{ 
              background: '#ffffff', 
              border: 'none', 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
            }}
            title={
              <Space style={{ fontSize: '20px', fontWeight: 600, color: '#262626' }}>
                <UserOutlined />
                三步轻松开户
              </Space>
            }
          >
            <Steps
              current={-1}
              className="enterprise-steps"
              items={[
                {
                  title: '会员开立',
                  description: '填写企业基本信息',
                  icon: <UserOutlined />,
                },
                {
                  title: '登记簿开立',
                  description: '二维码授权验证',
                  icon: <SafetyOutlined />
                },
                {
                  title: '银行卡绑定',
                  description: '绑定企业银行卡',
                  icon: <BankOutlined />
                },
                {
                  title: '开立完成',
                  description: '账户开立成功',
                  icon: <CheckCircleOutlined />
                }
              ]}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default IntroductionStep;